/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { useApi } from '../services';

export const useCreateSupportIssue = () => useApi(`/v2/support`, 'POST', {}, {}, true);